import { goToCart } from '@/services/FramedCheckout/navigationServices'
import { getCustomer } from '@/services/FramedCheckout/customerServices'

import { getFinalizedOrder } from '@/services/FramedCheckout/orderServices/getFinalizedOrder'
import { getBranding } from '@/services/FramedCheckout/brandServices'


import { log, error } from '@/services/Log'

export const initializeOrderConfirmation = async () => {
  log('Initialize OrderConfirmationPage')
  try {
    const order = await getFinalizedOrder({
      orderId: location.pathname.split('/').pop()
    })
    const branding = await getBranding()
    let customer;
    try {
      customer = await getCustomer(order)
    } catch {
      // Not a valid returning customer
    }
    return { success: true, order, branding, customer }
  } catch (err) {
    error(`Failed to initialize order confirmation  page:\t ${err}`, { error: err })
    await goToCart()
    return { success: false }
  }
}
